export default __webpack_public_path__ + "static/media/addActive.8181ba14.svg";